import React from 'react';
import { Grid, Paper, Skeleton, Box } from '@mui/material';
import './summaryGridSkeleton.css';

interface SummaryGridSkeletonProps {
  itemCount?: number;
}

const SummaryGridSkeleton: React.FC<SummaryGridSkeletonProps> = ({
  itemCount = 4,
}) => {
  return (
    <div className="dataTransferSummary">
      <Grid container spacing={3}>
        {Array.from({ length: itemCount }).map((_, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Paper className="summarySkeletonCard" elevation={2}>
              <Box className="summarySkeletonHeader">
                <div className="summarySkeletonIconContainer">
                  <Skeleton
                    variant="circular"
                    width={24}
                    height={24}
                    className="summarySkeletonIcon"
                  />
                </div>
                <div className="summarySkeletonTitleContainer">
                  <Skeleton
                    variant="text"
                    width="90%"
                    height={20}
                    className="summarySkeletonTitle"
                  />
                  <Skeleton
                    variant="text"
                    width="60%"
                    height={16}
                    className="summarySkeletonDescription"
                  />
                </div>
              </Box>

              <Box className="summarySkeletonValueContainer">
                <Skeleton
                  variant="text"
                  width="100%"
                  height={30}
                  className="summarySkeletonValue"
                />

                {/* <div className="summarySkeletonTrend">
                  <Skeleton
                    variant="circular"
                    width={16}
                    height={16}
                    className="summarySkeletonTrendIcon"
                  />
                  <Skeleton
                    variant="text"
                    width={30}
                    height={12}
                    className="summarySkeletonTrendValue"
                  />
                </div> */}
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default SummaryGridSkeleton;
